import React from "react";

const ServiceContent = [
  {
    icon: "icon-mobile",
    title: "Website Development",
    descriptions: `Skilled web developer with expertise in front-end and back-end technologies, creating seamless, user-friendly websites.`,
  },
  {
    icon: "icon-desktop",
    title: "Graphic Design",
    descriptions: `Talented graphic designer with a creative flair and technical proficiency, crafting visually stunning designs that captivate and engage audiences.`,
  },
  {
    icon: "icon-target",
    title: "Entrepreneurship",
    descriptions: `Innovative entrepreneur with a strategic mindset, adept at identifying opportunities, and fostering growth through creativity and determination.`,
  },
];
export default function Service() {
  return (
    <>
      <div className="row">
        {ServiceContent.map((val, i) => (
          <div className="col-md-6 col-lg-4 my-3" key={i}>
            <div className="feature-box-01">
              <div className="icon">
                <i className={`icon ${val.icon}`}></i>
              </div>
              <div className="feature-content">
                <h5>{val.title}</h5>
                <p>{val.descriptions}</p>
              </div>
            </div>
            {/* End .feature-box-01 */}
          </div>
        ))}
      </div>
    </>
  );
}
